module.exports = __webpack_public_path__ + "img/4door_parked.24d0f105.svg";